import { useQuery } from "@tanstack/react-query";
import { rpc } from "./rpc";
import { useFiltros } from "./filtros";

/**
 * Los globitos rojos del menú (Atender, Calidad, Comunidad, Riesgo, Dormidos,
 * Higiene). Portado de actualizarContadores() de app.js (líneas 3184-3203):
 * mismos RPCs, mismos parámetros y mismos criterios de conteo.
 *
 * Va aparte de las vistas a propósito: el número debe verse en el menú aunque
 * la persona nunca abra esa pantalla.
 */
export interface Contadores {
  tabNAtender: number;
  tabNCalidad: number;
  tabNComunidad: number;
  tabNRiesgo: number;
  tabNDormidos: number;
  tabNHigiene: number;
}

type ConClase = { clase_ia?: string | null };
type ConEstado = { estado?: string | null };

export function useContadores(): Partial<Contadores> {
  const { rango, sucursal } = useFiltros();
  const p = { p_desde: rango.desde, p_hasta: rango.hasta, p_sucursal: sucursal };
  const soloSuc = { p_sucursal: sucursal };

  const { data } = useQuery<Contadores>({
    queryKey: ["contadores", p],
    staleTime: 60_000,
    retry: 1,
    queryFn: async () => {
      const [al, cal, com, riesgo, dormidos, hg] = await Promise.all([
        rpc<ConClase[]>("api_alertas", soloSuc),
        rpc<{ alertas?: unknown[] }>("api_calidad", p),
        rpc<ConEstado[]>("api_comunidad", soloSuc),
        rpc<unknown[]>("api_clientes_en_riesgo", soloSuc),
        rpc<unknown[]>("api_clientes_dormidos", soloSuc),
        rpc<{ fuentes_sospechosas?: unknown[] }>("api_higiene", p),
      ]);
      return {
        // las cortesías no cuentan como pendiente de atender (igual que el original)
        tabNAtender: (al ?? []).filter((a) => a.clase_ia !== "cortesia").length,
        tabNCalidad: (cal?.alertas ?? []).length,
        tabNComunidad: (com ?? []).filter((a) => a.estado === "sin_respuesta").length,
        tabNRiesgo: (riesgo ?? []).length,
        tabNDormidos: (dormidos ?? []).length,
        tabNHigiene: (hg?.fuentes_sospechosas ?? []).length,
      };
    },
  });

  return data ?? {};
}
